module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 301);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("classnames/bind");

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Tooltip = __webpack_require__(302);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Tooltip2.default;

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _bind = __webpack_require__(3);

var _bind2 = _interopRequireDefault(_bind);

var _reactTether = __webpack_require__(303);

var _reactTether2 = _interopRequireDefault(_reactTether);

var _Caret = __webpack_require__(304);

var _Caret2 = _interopRequireDefault(_Caret);

var _size = __webpack_require__(305);

var _size2 = _interopRequireDefault(_size);

var _general = __webpack_require__(306);

var _general2 = _interopRequireDefault(_general);

var _type = __webpack_require__(307);

var _type2 = _interopRequireDefault(_type);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var tooltipStyle = _extends({}, _size2.default, _general2.default, _type2.default);
var cx = _bind2.default.bind(tooltipStyle);

var tooltipPosition = ['top left', 'top center', 'top right', 'middle left', 'middle center', 'middle right', 'bottom left', 'bottom center', 'bottom right'];

var customClasses = getCustomClasses();

var Tooltip = function (_Component) {
  _inherits(Tooltip, _Component);

  function Tooltip() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hover: false
    }, _this.invertHover = function () {
      _this.setState({ hover: !_this.state.hover });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Tooltip, [{
    key: 'render',
    value: function render() {
      var hover = this.state.hover;


      var tooltipClasses = cx('tooltip', this.props.size, this.props.type);

      var caretClasses = cx('caret', 'caret-' + this.props.type);

      return _react2.default.createElement(
        _reactTether2.default,
        {
          attachment: this.props.position,
          constraints: [{
            to: 'window',
            attachment: 'together'
          }],
          classes: customClasses
        },
        _react2.default.createElement(
          'div',
          {
            className: _general2.default.container,
            onMouseOver: this.invertHover,
            onMouseOut: this.invertHover
          },
          this.props.children
        ),
        hover && _react2.default.createElement(
          'div',
          { className: _general2.default.wrap },
          _react2.default.createElement(
            'div',
            { className: tooltipClasses },
            this.props.text,
            _react2.default.createElement(
              'div',
              { className: caretClasses },
              _react2.default.createElement(_Caret2.default, null)
            )
          )
        )
      );
    }
  }]);

  return Tooltip;
}(_react.Component);

exports.default = Tooltip;


Tooltip.propTypes = {
  children: _propTypes2.default.node.isRequired,
  position: _propTypes2.default.oneOf(tooltipPosition).isRequired,
  size: _propTypes2.default.oneOf(Object.keys(_size2.default)).isRequired,
  text: _propTypes2.default.string.isRequired,
  type: _propTypes2.default.oneOf(Object.keys(_type2.default)).isRequired
};

Tooltip.defaultProps = {
  position: 'bottom center',
  size: 'medium',
  type: 'dark'
};

function getCustomClasses() {
  return ['bottom', 'top', 'left', 'right', 'middle', 'center'].reduce(function (classes, pos) {
    /* eslint-disable no-param-reassign */
    classes[getDefaultClass(pos)] = _general2.default[pos];
    return classes;
  }, {});
}

function getDefaultClass(position) {
  return 'element-attached-' + position;
}

/***/ }),

/***/ 303:
/***/ (function(module, exports) {

module.exports = require("react-tether");

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Caret;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Caret() {
  return _react2.default.createElement(
    "svg",
    { className: "display-block", width: "10", height: "4", viewBox: "0 0 10 4" },
    _react2.default.createElement("path", { d: "M0,0H10L5.62,3.78a1,1,0,0,1-1.25,0Z" })
  );
}

/***/ }),

/***/ 305:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"small":"size__small___3_PPZ borderRadius-s fontSize-xs lineHeight-s paddingLeftRight-xxs","medium":"size__medium___sClcu borderRadius-s fontSize-s lineHeight-m paddingLeftRight-xs"};

/***/ }),

/***/ 306:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"general__container___1thju display-inlineBlock position-relative","tooltip":"general__tooltip____n1SX whiteSpace-nowrap position-relative","wrap":"general__wrap___2xAbq padding-xxs","caret":"general__caret___3uXnm position-absolute","caret-dark":"general__caret-dark___1T6YA fill-black--translucent","caret-light":"general__caret-light___vmJgq fill-white--translucent","caret-black":"general__caret-black___-tb_e fill-licorice--translucent","bottom":"general__bottom___3U8s4","top":"general__top___2JmeE","left":"general__left___3VNOF","right":"general__right___2xmnx","middle":"general__middle___3kt66","center":"general__center___29cb_"};

/***/ }),

/***/ 307:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"dark":"type__dark___2mIFH bg-black--translucent c-white","light":"type__light___HV8pF bg-white--translucent c-slate","black":"type__black___Avzqc bg-licorice--translucent c-white"};

/***/ })

/******/ });
//# sourceMappingURL=marvel-ui-tooltip.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@marvelapp/marvel-ui/lib/marvel-ui-tooltip.js
// module id = 1117
// module chunks = 71833740541355